var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('v-button',{staticClass:"feed__subscribe-button",attrs:{"type":"button","rounded":"","secondary":_vm.isOn,"is-loading":_vm.isToggling},on:{"click":_vm.toggleSubscribe}},[(!_vm.isOn)?[_c('v-icon',{staticClass:"mr-1",attrs:{"icon":"notifications_active","size":"16px"}}),_vm._v(" "+_vm._s(_vm.$t("components.messageThread.subscribeButton.subscribe"))+" ")]:[_c('v-icon',{attrs:{"icon":"notifications_off"}})]],2),_c('alert-dialog',{attrs:{"title":_vm.$t('components.messageThread.subscribeButton.dialogTitle'),"actions":[
      {
        title: _vm.$t('components.messageThread.subscribeButton.dialogCancel'),
        callback: function () { return (this$1.showUnsubscribeDialog = false); }
      },
      {
        title: _vm.$t(
          'components.messageThread.subscribeButton.dialogUnsubscribe'
        ),
        callback: _vm.toggle
      }
    ],"show":_vm.showUnsubscribeDialog,"centered":""},on:{"close":function () { return (this$1.showUnsubscribeDialog = false); }}},[_vm._v(" "+_vm._s(_vm.$t("components.messageThread.subscribeButton.dialogContent"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }